import React, { useState } from "react";
import { Menu } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import type { ISiteScheduleExceptionsRepository } from "App/Modules/Repositories";
import { faCheck } from "@fortawesome/pro-light-svg-icons";
import { MenuItemWithIcon } from "App/ReactComponents/Shared";
import { analysisPartiallyEnabled } from "../../../Img/Icons";
import { ScheduleExceptionsDialog } from "../ScheduleExceptions";
import type { CombinedSite } from "../../Models";

type SitesListMenuItemProps = {
    anchorEl: Element;
    site: CombinedSite;
    siteScheduleExceptionsRepository: ISiteScheduleExceptionsRepository;
    onAcknowledgeAll: () => void;
    onAcknowledgeAllResolved: () => void;
    showAcknowledgeAll: boolean;
    isOpen: boolean;
    onClose: () => void;
};

export const SitesListMenuItem = (props: SitesListMenuItemProps) => {
    const { t } = useTranslation();

    const [isScheduleExceptionsDialogOpen, setIsScheduleExceptionsDialogOpen] = useState(false);

    const closeMenu = () => {
        props.onClose();
    };

    const handleScheduleExceptionClick = () => {
        closeMenu();
        setIsScheduleExceptionsDialogOpen(true);
    };

    const handleCloseScheduleExceptionsDialog = () => {
        setIsScheduleExceptionsDialogOpen(false);
    };

    const handleAcknowledgeAllClick = () => {
        closeMenu();
        props.onAcknowledgeAll();
    };

    const handleAcknowledgeAllResolvedClick = () => {
        closeMenu();
        props.onAcknowledgeAllResolved();
    };

    return (
        <>
            <Menu
                open={props.isOpen}
                onClose={() => closeMenu()}
                anchorEl={props.anchorEl}
                getContentAnchorEl={null}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
            >
                <MenuItemWithIcon onClick={() => handleScheduleExceptionClick()} icon={analysisPartiallyEnabled}>
                    {t("Entities.ScheduleException.Manage")}
                </MenuItemWithIcon>
                {props.showAcknowledgeAll && (
                    <MenuItemWithIcon
                        onClick={() => handleAcknowledgeAllClick()}
                        icon={faCheck}
                        disabled={!props.site?.numIssuesNew}
                    >
                        {t("Entities.Issue.AcknowledgeAllIssuesFormat", {
                            count: props.site?.numIssuesNew,
                        })}
                    </MenuItemWithIcon>
                )}
                {props.showAcknowledgeAll && props.site?.issues && (
                    <MenuItemWithIcon
                        onClick={() => handleAcknowledgeAllResolvedClick()}
                        icon={faCheck}
                        disabled={props.site?.issues.filter((i) => !i.isAcknowledged && !i.isActive).length < 1}
                    >
                        {t("Entities.Issue.AcknowledgeAllResolvedFormat", {
                            count: props.site?.issues.filter((i) => !i.isAcknowledged && !i.isActive).length,
                        })}
                    </MenuItemWithIcon>
                )}
            </Menu>
            <ScheduleExceptionsDialog
                isOpen={isScheduleExceptionsDialogOpen}
                onClose={() => handleCloseScheduleExceptionsDialog()}
                site={props.site}
                siteScheduleExceptionsRepository={props.siteScheduleExceptionsRepository}
                requestingUser={null}
            />
        </>
    );
};
